import EmailWithMetrics from "@mapmycustomers/shared/types/email/EmailWithMetrics";
import { Activity } from "@mapmycustomers/shared/types/entity";

import getEmailMetricsCounts, { EmailMetricsCounts } from "./getEmailMetricsCounts";
import isEmailDelivered from "./isEmailDelivered";

export type ActivityEmailMetrics =
  | { counts: EmailMetricsCounts; type: "aggregate" }
  | { log: EmailWithMetrics | null; type: "single" };

const getActivityEmailMetrics = (activity: Activity): ActivityEmailMetrics => {
  const logs = activity.emailLogs ?? [];

  if (logs.length > 1) {
    return { counts: getEmailMetricsCounts(logs), type: "aggregate" };
  }

  // The single path renders `opened` straight off the log, so it would show a bounced
  // recipient as having opened the email. Send a lone undelivered log through the counts.
  const log = logs[0] ?? activity.emailLog ?? null;
  if (log && !isEmailDelivered(log)) {
    return { counts: getEmailMetricsCounts([log]), type: "aggregate" };
  }

  return { log, type: "single" };
};

export default getActivityEmailMetrics;
